<app-mu-modal-dialog-layout
  [title]="'authLogin.terms.modal.title' | translate"
  [icon]="'mu-icon mu-icon-info-circle'"
  [buttonMainActionLabel]="'form.button.accept' | translate"
  [showFlag]="flagEnum.SHOW_TERMS_MODAL"
  [actionFlag]="flagEnum.ACTION_TERMS_MODAL"
  [loaderFlag]="flagEnum.ACTION_TERMS_MODAL"
  [flagList]="flagList"
  [bigContent]="true"
>
  <p
    modalDialogContent
    class="p-col-12 mu-modal-text mu-without-padding"
    [innerHTML]="
      'authLogin.terms.modal.text' | translate: { termsLink: termsLinks?.terms, politicsLink: termsLinks?.politics, email: contactEmail }
    "
  ></p>
</app-mu-modal-dialog-layout>
